import { getQueryParameters } from "../Wizards/Entities/QueryParametersHelper";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { RestrictionStore } from "../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { RestrictionAction } from "../../Dashboard/Components/Clients/Common/Restrictions/RestrictionAction";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { IWizardComponentStateGeneric, WizardComponentGeneric } from "./WizardComponentGeneric";
import React from "react";
import { PartLoading } from "../../../react-core/Html/PartLoading";
import { Customer } from "../../../Wrap/Models/Domains/Users/Customer";
import { AccountRoleStore, ClientAccountStore } from "../../Dashboard/Stroes/Variable";
import { Action } from "../../Dashboard/Actions/Action";

export interface IAccountContextWizardComponentState extends IWizardComponentStateGeneric {
    customer: Customer;
    clientAccount: ClientAccount;
    isRestrictionLoading?: boolean;
}

export abstract class AccountContextWizardComponent<
    TState extends IAccountContextWizardComponentState
> extends WizardComponentGeneric<TState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(RestrictionStore, () => this.onRestrictionStoreChange());
        this.subscribeToStore(ClientAccountStore, () => this.onClientAccountStoreChange());
        this.subscribeToStore(AccountRoleStore, () => this.onAccountRoleStoreChange());
    }

    onRestrictionStoreChange() {
        if (RestrictionStore.getActionType() == ActionType.Success) {
            this.setState({ isRestrictionLoading: false });
        }
    }

    onAccountRoleStoreChange(): void {
        const accountRole = AccountRoleStore.getAccountRoles()?.find((x) => x.IsPrimary);
        this.setState({ customer: accountRole?.Customer });
    }

    onClientAccountStoreChange(): void {
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        this.setState({ clientAccount: clientAccount });
    }

    componentDidMount() {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            Action.getClientAccount(hierarchyId);
            Action.getAccountRoles(hierarchyId);
        }

        if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
            RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["subaccounthierarchyid"]);
        } else if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            RestrictionAction.getRestrictionByHierarchyId(hierarchyId);
        } else {
            this.setState({ isRestrictionLoading: false });
        }
    }

    protected wizardRender() {
        if (this.state.isRestrictionLoading) {return <PartLoading isLoading={true} />;}
        return super.wizardRender();
    }

    protected setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${this.state.customer?.PersonalDetails?.Name?.Given} ${this.state.customer?.PersonalDetails?.Name?.Family}`,
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        return processProps;
    }
}
